import React, { Component } from 'react';

/**
 * Component showing a dialog where the user can cancel or confirm an deletion request.
 * ---
 * Needs props:
 * - titleText (string): Text used for the title.
 * - elementText (string): Text with short information about the item thats to be deleted
 * - confirmationButton: Button text of the confirmation button (Ja, Löschen etc.)
 * - cancelButton: Optional, name of the cancel button
 * - cancel (function): Function to execute on click on cancel button
 * - confirmAction (function): Function to execute on action (submit/yes/delete button clicked)
 */
class ConfirmationDialog extends Component {
    render() {
        return (
            <div className={'dialog-background'}>
                <dialog open className={'confirmation-dialog'}>
                    <h5>{this.props.titleText}</h5>
                    <p><strong>{this.props.elementText}</strong></p>
                    <div style={{display: "flex", justifyContent: "space-between"}}>
                        <button className="btn btn-outline-form" style={{marginBottom: "0"}} onClick={() => this.props.cancel()}>
                            {this.props.cancelButton ? this.props.cancelButton : "Abbrechen"}
                        </button>
                        <button className="btn btn-outline-form" style={{color: "red", marginBottom: "0"}} onClick={() => this.props.confirmAction()}>
                            {this.props.confirmationButton ? this.props.confirmationButton : "Ja"}
                        </button>
                    </div>
                </dialog>
            </div>
        );
    }
}

export default ConfirmationDialog;
